export default {
	namespaced: true,
	state: {
		winHeight: 0, //布局等效高度：窗口高度加隐藏顶栏释放的空间，兼容现有列表扣减公式。
	},
	mutations: {
		// 更新列表共用的等效高度，布局切换和窗口缩放均由 App 统一计算。
		setWinHeight(state, h) {
			state.winHeight = h
		},
	}
}
